import { initAppointmentForm } from '../appointmentForm/dcAppointmentForm';

document.addEventListener('DOMContentLoaded', function () {
  initAppointmentForm();
});
